import { LOGOUT_USER, SET_USER } from "redux/actions/actionTypes";
import { UPDATE_USER_POINT } from "redux/actions/actionTypes";
import { USER_ACTIONS } from "../actions/user";

const initialState = {
  customer: null,
  customerToken: null,
  company: null,
  isSubscribe: false,
  user: null,
  userStatus: "pending",
  reloadContactCredit: false,
  firebaseToken: null,
};

// Update 6/9/2025: All actions now update contact_quota as unified currency

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_COMPANY":
      return {
        ...state,
        company: action.payload,
      };

    case "RESET_CUSTOMER":
      return {
        ...state,
        customer: null,
        customerToken: null,
      };

    case "SET_CUSTOMER":
      return {
        ...state,
        customer: action.payload,
      };

    case "SET_CUSTOMER_TOKEN":
      return {
        ...state,
        customerToken: action.payload,
      };

    case "SET_IS_SUBSCRIBE":
      return {
        ...state,
        isSubscribe: action.payload,
      };

    case SET_USER:
    case "SET_USER": {
      return {
        ...state,
        user: action.payload,
        userStatus: action.payload?.userStatus,
      };
    }

    case LOGOUT_USER:
    case "LOGOUT_USER": {
      return {
        ...state,
        user: null,
        company: null,
      };
    }

    case UPDATE_USER_POINT: {
      return {
        ...state,
        user: {
          ...state.user,
          balance: { ...(state.user?.balance || {}), contact_quota: action.payload },
        },
      };
    }

    case USER_ACTIONS.updateUserContactQuote: {
      return {
        ...state,
        user: {
          ...state.user,
          balance: {
            ...(state.user?.balance || {}),
            contact_quota: action.payload,
          },
        },
      };
    }

    case USER_ACTIONS.updateUserCreditChat: {
      return {
        ...state,
        user: {
          ...state.user,
          balance: {
            ...(state.user?.balance || {}),
            contact_quota: action.payload,
          },
        },
      };
    }

    case "SET_COMPANY": {
      return {
        ...state,
        company: action.payload,
      };
    }

    case "UPDATE_FIREBASE_TOKEN": {
      return {
        ...state,
        firebaseToken: action.payload,
      };
    }

    case USER_ACTIONS.reloadContactCredit: {
      return {
        ...state,
        reloadContactCredit: !state?.reloadContactCredit,
      };
    }

    default:
      return state;
  }
};

export default userReducer;
